import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const WarningMessage = styled('div')`
  display: flex;
  flex-direction: column;
  font-size: 20px;
  text-align: center;
  color: ${colors.gray300};

  button {
    margin: 24px auto 0;
  }
`

export const WarningWrapper = styled.div`
  align-items: center;
  flex-direction: column;
  display: flex;
  justify-content: center;
  height: 90vh;
  width: 100%;
`
